const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  // Convert old /api/uploads/hash.ext paths to new /api/files/hash format
  if (path.startsWith('/api/uploads/')) {
    const filename = path.replace('/api/uploads/', '');
    const fileId = filename.replace(/\.[^.]+$/, '');
    return `${BACKEND}/api/files/${fileId}`;
  }
  return `${BACKEND}${path}`;
};
